import React, { useEffect, useState } from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router";
import "./ProjectDetails.css";

// Carousel

const ProjectDetails = () => {
  // Step: Get every single order from Database through the "orderId"
  const { projectId } = useParams();
  const [project, setProject] = useState({});

  useEffect(() => {
    fetch(`https://radiant-meadow-70732.herokuapp.com/allProjects/${projectId}`)
      .then((res) => res.json())
      .then((data) => setProject(data));
  }, []);

  return (
    <div className="project-section">
      <Container className="project-container">
        <Row>
          {/* First Column Images */}
          <Col sm={12} md={6}>
            <div className="carousel-section">
              <Carousel className="carousel-items">
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={project.detailImg1}
                    alt="First slide"
                  />
                  <Carousel.Caption></Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={project.detailImg2}
                    alt="Second slide"
                  />
                  <Carousel.Caption></Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={project.detailImg3}
                    alt="Third slide"
                  />
                  <Carousel.Caption></Carousel.Caption>
                </Carousel.Item>
              </Carousel>
            </div>
          </Col>

          {/* Second Column GET Method (Via Fetch)  */}
          <Col sm={12} md={6}>
            <div className="project-text">
              <h3>{project.projectTitle}</h3>
              <h6>{project.brief}</h6>
              <p>{project.description}</p>
            </div>

            <div className="project-location">
              <button className="bk-button2">
                <a href={project.site} target="_blank">
                  Live Site
                </a>
              </button>
              <button className="bk-button2">
                <a href={project.client} target="_blank">
                  Client Side
                </a>
              </button>
              <button className="bk-button2">
                <a href={project.server} target="_blank">
                  Server Side
                </a>
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProjectDetails;
